import React from 'react';
import { SIcon, STabs, STooltip } from '@chargebee/sting-react';
import { DemoDataBanner } from '@bbkAdminComponents/get-started/demo-data-banner';
import { useShowPlayDemoData } from '@bbkAdminComponents/play/use-show-demo-data';
import { DatePickerV2 } from '@bbkAdminComponents/reports-filter-picker/reports-filter-picker';
import PlayExpPerf from '@bbkAdminComponents/unified-plays/reporting/reports/cancel-page/play-exp-perf';
import PlayOfferPerf from '@bbkAdminComponents/unified-plays/reporting/reports/cancel-page/play-offer-perf';
import { type PlayEdit } from '@bbkAdminRedux/rtkq/play.slice';

export type CancelPlayReportProps = {
  play: PlayEdit;
};

//TODO: Post master merge, restructure directory, organize subcomponents + parent pages in report type based folders
//TODO: Add demo data banner to in app offer page
const CancelPageReports: React.FC<CancelPlayReportProps> = (props) => {
  const isDemoData = useShowPlayDemoData();

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      <DemoDataBanner />
      <STabs defaultValue="exp-perf" variant="default">
        <div className="tw-flex tw-flex-row tw-flex-wrap tw-items-center tw-justify-between">
          <STabs.List>
            <STabs.Trigger value="exp-perf" className="!tw-bg-transparent">
              <SIcon name="circle-x" size={16} />
              Experience Performance
            </STabs.Trigger>
            <STabs.Trigger value="offer-perf" className="!tw-bg-transparent">
              <SIcon name="gift" size={16} />
              Offer Performance
            </STabs.Trigger>
          </STabs.List>
          <STooltip
            label="Disabled in demo mode."
            width="regular"
            placement="left"
            enabled={isDemoData}
          >
            <div className="tw-inline-block">
              <DatePickerV2 disabled={isDemoData} />
            </div>
          </STooltip>
        </div>
        <STabs.Content value="exp-perf">
          <PlayExpPerf {...props} />
        </STabs.Content>
        <STabs.Content value="offer-perf">
          <PlayOfferPerf {...props} />
        </STabs.Content>
      </STabs>
    </div>
  );
};

export default CancelPageReports;
